import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { CatalogComponent } from './catalog.component';
import { TvbLayoutModule } from '../layout/tvb-layout.module';
import { SharedModule } from '@shared/shared.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ProductDetailViewComponent } from './pages/product-detail-view/product-detail-view.component';
import { ImagesCarouselComponent } from '@shared/components/images-carousel/images-carousel.component';
import { HttpClient } from '@angular/common/http';
import { CreatealertComponent } from '../catalog/components/createalert/createalert.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { ConditionDialogComponent } from './components/dialogs/condition-dialog/condition-dialog.component';
import { SellerVisionComponent } from '@shared/components/seller-vision/seller-vision.component';
import { CatalogDictionaryPipe } from '@shared/pipes/catalog-dictionary.pipe';
import { ListingViewElkComponent } from './pages/listing-view-elk/listing-view-elk.component';
import { FiltersSectionComponent } from './components/search/filters-section/filters-section.component';
import { FilterBoxComponent } from './components/search/filters-section/filter-box/filter-box.component';
import { ProductCardElkComponent } from './pages/listing-view-elk/product-card-elk/product-card-elk.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MotherPageComponent } from './pages/listing-view-elk/mother-page/mother-page.component';
import { PlpFiltersMobileMenuComponent } from './pages/listing-view-elk/plp-filters-mobile-menu/plp-filters-mobile-menu.component';
import { ClothesSizeDialogComponent } from './components/dialogs/clothes-size-popup-dialog/clothes-size-popup-dialog.component';
import { ShoesSizeDialogComponent } from './components/dialogs/shoes-size-popup-dialog/shoes-size-popup-dialog.component';

@NgModule({
  declarations: [
    CatalogComponent,
    ProductDetailViewComponent,
    ImagesCarouselComponent,
    CreatealertComponent,
    ConditionDialogComponent,
    SellerVisionComponent,
    ListingViewElkComponent,
    FiltersSectionComponent,
    ClothesSizeDialogComponent,
    ShoesSizeDialogComponent,
    FilterBoxComponent,
    ProductCardElkComponent,
    MotherPageComponent,
    PlpFiltersMobileMenuComponent,
  ],
  providers: [CatalogDictionaryPipe, CurrencyPipe],
  imports: [
    CommonModule,
    TvbLayoutModule,
    CarouselModule,
    SharedModule,
    NgxSliderModule,
    RouterModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxPaginationModule,
  ],
  exports: [
    ProductDetailViewComponent,
    CreatealertComponent,
    RouterModule,
    SellerVisionComponent,
    ListingViewElkComponent,
    FiltersSectionComponent,
    FilterBoxComponent,
    ProductCardElkComponent,
  ],
})
export class CatalogModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
